export const ADMIN_API_CONFIG = { noRedirectOn401: true };

export const CONTROLE_BIS_DOSSIER_TYPE = "CONTROLE_BIS_PRODUCTION";

export const CONTROLE_MODE_LABELS = {
    NETSOIN: "Netsoin",
    TITAN: "Titan",
    DOMINLIK_IMAGO: "Dominlik et Imago",
    SANS_LOGICIEL: "Sans logiciel",
};

export const isAppleKeyboard = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

export const saveShortcutLabel = isAppleKeyboard ? "⌘ S" : "Ctrl S";

export function emptySection(section) {
    return Object.fromEntries(section.rows.map(([key]) => [key, {}]));
}

export function statusLabel(status) {
    return status === "TERMINE" ? "Terminé" : "Brouillon";
}

export function controleModeLabel(mode) {
    return CONTROLE_MODE_LABELS[mode] || "Non défini";
}

export const NON_CONFORMITY_PRODUCTION_ROWS = [
    ["comprimesDecales", "Comprimés/gélules décalés"],
    ["integriteMedicament", "Perte d'intégrité du médicament (gélule éclatée, comprimés cassé...)"],
    ["quantiteInexacte", "Quantité inexacte de comprimé/gélule"],
    ["elementEtranger", "Élément étranger"],
    ["aspectPilulier", "Aspect non conforme du pilulier (encre, froissé, décollé...)"],
];

export const NON_CONFORMITY_TECHNICAL_ROWS = [
    ["erreurPlateau", "Erreur plateau FSP/MDU"],
    ["panneBloquante", "Panne bloquante"],
    ["erreurRemplissage", "Erreur de remplissage"],
    ["erreurManipulation", "Erreur de manipulation"],
    ["problemeInformatique", "Problème informatique"],
];

export const PRODUCTION_CONTROL_ROWS = [
    ["temperatureSoudure", "Température de soudure", "80-85°C"],
    ["humiditeAir", "Humidité de l'air ambiant", "30-40%"],
    ["scellageSachets", "Scellage des sachets", "Étanchéité assurée"],
    ["controleVisuel", "Contrôle visuel (absence de défauts, aspect uniforme)", "Conforme"],
    ["conditionnementEtiquetage", "Conditionnement et étiquetage", "Correctement aligné"],
];

export const LOT_RELEASE_ROWS = [
    ["dateDebutTraitement", "DATE de début de traitement (semaine de traitement)"],
    ["patientLisible", "NOM ET PRÉNOM PATIENT LISIBLE"],
    ["tracabiliteOrdonnance", "TRAÇABILITÉ ORDONNANCE"],
    ["productionSachet", "PRODUCTION SACHET"],
    ["nomEhpad", "NOM DE L’EHPAD"],
    ["nombreSachet", "NOMBRE DE SACHET"],
    ["descriptionMedicaments", "DESCRIPTION DES MÉDICAMENTS"],
];

export const YIELD_ROWS = [
    ["patientProduit", "PATIENT PRODUIT"],
    ["patientCaisseLivraison", "PATIENT MISE EN CAISSE LIVRAISON"],
    ["residentEhpad", "NOMBRE DE RÉSIDENT EHPAD"],
];
